import React from 'react';
import cn from 'classnames';
import JournalDumbView from '../../../DeviationViews/Dumbo/Journal';
import { Props } from '../MonoView';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';

import s from './Journal.scss';

const JournalView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);

  return (
    <div className={cn(s['root'])} style={{ width: size.width }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <JournalDumbView width={size.width} height={size.height} deviation={deviation} />
      </EditorDeviationLink>
    </div>
  );
};
JournalView.displayName = 'JournalView';

export default JournalView;
